module.exports = require("tiny-js-md5");